import { useNavigate } from 'react-router';
import { RectangleListIcon } from "../../../icons"

const MenuItems = (id: number, withoutMenuSections: boolean) => {
  const navigate = useNavigate();
  const showActions = () => navigate('/menus/' + id + '/menu_items');
  return (
    <span
      className="group relative inline-flex"
      tabIndex={withoutMenuSections ? 0 : undefined}
      aria-describedby={withoutMenuSections ? `menu-items-tooltip-${id}` : undefined}
    >
      {withoutMenuSections && (
        <span
          id={`menu-items-tooltip-${id}`}
          role="tooltip"
          className="pointer-events-none absolute bottom-full left-1/3 z-50 mb-2
            -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-600
            px-2.5 py-1.5 text-xs font-medium text-white opacity-0 
            shadow-lg transition-opacity opacity-100 md:opacity-0
            md:group-hover:opacity-100 md:group-focus-visible:opacity-100
            dark:bg-gray-200 dark:text-gray-900"
        >
          Create sections before creating items
        </span>
      )}
      <button
        onClick={showActions}
        className='
          flex items-center justify-center gap-2 rounded-full border 
          border-gray-300 bg-white px-4 py-3 text-sm font-medium 
          text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 
          dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 
          lg:inline-flex lg:w-auto  
          disabled:cursor-not-allowed disabled:opacity-50
        '
        disabled={withoutMenuSections}
      >
        <RectangleListIcon width={20} height={20}/>
        Items
      </button>
      
    </span>
  );
}

export default MenuItems;
